import { useContext } from 'react';
import { HeaderRootContext } from '../HeaderRootContext.js';

var useHeaderRootContext = function useHeaderRootContext() {
  var context = useContext(HeaderRootContext);
  if (context === undefined) {
    throw new Error('useHeaderRootContext must be used within a HeaderRootProvider');
  }
  return context;
};

export { useHeaderRootContext };
//# sourceMappingURL=useHeaderRootContext.js.map
